const TreeTalkAPI = process.env.API_URL;

export default {
  project: process.env.FMP_PROJECT,
  SURVEY_GUID: process.env.SURVEY_GUID, // update wording from Dan

  getURI (urlparams, queryparams) {
    if (!queryparams) {
      return TreeTalkAPI + urlparams;
    } else {
      return TreeTalkAPI + urlparams + '?' + queryparams;
    }
  },

};



// WEBPACK FOOTER //
// ./src/lib/config.js